import { Box, Button, Text, useMultiStyleConfig } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useIsMobile } from 'app/utils/hooks';

const MIN_BUTTON_WIDTH = '88px';

export const Import = () => {
  const isMobileView = useIsMobile(false);
  const styles = useMultiStyleConfig('SettingsPageList', {
    isMobile: isMobileView,
    minButtonWidth: MIN_BUTTON_WIDTH,
  });

  const primaryText = 'Import';
  const secondaryText =
    'Migrate your metadata and audio files to Session Studio or upload bulk audio files.';

  return (
    <Box sx={styles.container}>
      <Box sx={styles.textWrapper}>
        <Text sx={styles.primaryText} pt={2} title={primaryText}>
          {primaryText}
        </Text>
        <Text
          sx={styles.secondaryText}
          data-testid="secondary-privacy-text"
          title={secondaryText}
        >
          {secondaryText}
        </Text>
      </Box>
      <Button
        as={Link}
        size="sm"
        p={0}
        minWidth={MIN_BUTTON_WIDTH}
        variant="secondary"
        to="/import"
      >
        Import
      </Button>
    </Box>
  );
};
